import { defineStore } from "pinia";
import { ref } from "vue";
import { createStatusApi } from "#ce/apps/SpInsuranceApp/api/status";
import { Status } from "#ce/apps/SpInsuranceApp/models/status";

export const useSharedStatusStore = (props) => {
  const api = props.statusApi ?? createStatusApi(props.url);

  const init = defineStore("status", () => {
    const status = ref(null);

    async function load(insurancePlanId) {
      status.value = await api.status(insurancePlanId);
    }

    return {
      // state
      status,

      // actions
      load,
    };
  });

  return init();
};

export const useStatusStore = (attributes) => ({
  // state
  status: Status.from(attributes),
});
